import gql from 'graphql-tag';

const DISCONNECT_PICKER = gql`
    mutation disconnectPicker ($email: String!) {
        disconnectPicker (email: $email) {
            message,
            status,
            data
        }
    }
`;

export default DISCONNECT_PICKER;
